import styled from 'styled-components'

export const MultipleActionsCard = styled.div`
  display: flex;
  padding: 20px 10px;
  justify-content: center;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #009eff;
  background: #fff;
  min-height: 100px;
  max-height: 43px;
  width: 70%;
`

export const CardBase = styled.div<{gap?: string; background?: string; border?: string; width?: string}>`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  max-height: 43px;
  gap: ${({gap}) => gap};
  background: ${({background}) => (background ? background : '#FFF')};
  border: ${({border, theme}) => (border ? border : `1px solid ${theme.colors.primary}`)};
  width: ${({width}) => width && width};
`

export const LabelOnCard = styled.span<{color: string}>`
  color: ${({color}) => color};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  max-width: 210px;
  overflow: hidden;
  white-space: nowrap;
`
export const LabelOnMultipleCard = styled.span<{fontWeight: string}>`
  color: #686868;
  font-size: 12px;
  font-style: normal;
  font-weight: ${({fontWeight}) => fontWeight};
  line-height: normal;
`
